module.exports = __webpack_public_path__ + "static/media/insights6.9152b550.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/insights6.png
// module id = 839
// module chunks = 10